import { render, staticRenderFns } from "./InvoiceTasksSection.vue?vue&type=template&id=b8b8f26a"
import script from "./InvoiceTasksSection.vue?vue&type=script&lang=js"
export * from "./InvoiceTasksSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports